import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'atw-block-chatbox-admin',
  templateUrl: './block-chatbox-admin.component.html',
  styleUrls: ['./block-chatbox-admin.component.scss']
})
export class AtwBlockChatboxAdmin implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
